module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_6000.feaeba7e.png";